import React, { Component } from 'react';
import './App.scss';
import Animation from './Animation/Animation.js';
import Link from './Link/Link.js';

import LinkedinIcon from 'mdi-react/LinkedinIcon';
import TwitterIcon from 'mdi-react/TwitterIcon';
import InstagramIcon from 'mdi-react/InstagramIcon';

class App extends Component {
  render() {
    return (
      <div className="app">
        <Animation/>
        <div className="container-fluid">
          <section>
            <div className="row center-xs intro">
              <div className="col-xs-12 col-sm-10 col-md-7 col-lg-6">
                <h2>I’m <strong>Bryan Loh</strong>, a <strong>software developer</strong> and <strong>designer</strong> specialising in the craft of making <strong>fun</strong>, <strong>useful</strong> and <strong>human</strong> software.</h2>
                <div className="description">
                  <p>Currently building the next generation of creativity tools at <Link href="https://runwayml.com/" target="_blank" rel="noopener noreferrer">RunwayML</Link>.</p>
                  <br/>
                  <p>Previously at <Link href="https://la.disneyresearch.com/" target="_blank" rel="noopener noreferrer">Disney Research</Link>, <Link href="https://www.end-game.com/" target="_blank" rel="noopener noreferrer">EndGame</Link> and <Link href="https://www.snapper.co.nz/" target="_blank" rel="noopener noreferrer">Snapper</Link> creating <strong>productivity tools</strong>, <strong>mobile applications</strong>, <strong>data visualizations</strong>, and <strong>responsive websites</strong>.</p>
                  <br/>
                  <p>Interested in new ways to interact with computers — check out my <Link href="https://vusd.github.io/spacesheet/" target="_blank" rel="noopener noreferrer">Master's project</Link> and <Link href="https://www.notion.so/Experiments-WIP-d54fdfc121e14ab38cffcfa73359a00d" target="_blank" rel="noopener noreferrer">random experiments</Link>.</p>
                  <br/>
                  <p>In my free time you can find me <Link href="https://www.notion.so/Doodles-676d411d812f43109cf9792c2e04bd97" target="_blank" rel="noopener noreferrer">doodling</Link> or <Link href="https://www.goodreads.com/review/list/89975376-bryan-loh?per_page=infinite&shelf=read&utf8=%E2%9C%93" target="_blank" rel="noopener noreferrer">deep in a book</Link>.</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="row center-xs location">
              <div className="col-xs-12 col-sm-10 col-md-7 col-lg-6">
                <p>Based in Wellington, New Zealand.<br/>Available worldwide.</p>
              </div>
            </div>

            <div className="row center-xs contact">
              <div className="col-xs-12">
                <h1><Link href="mailto:bryanlohjy@gmail.com?subject=Hello!">bryanlohjy@gmail.com</Link></h1>
              </div>
            </div>

            <div className="row center-xs icons">
              <div className="col-xs-12">
                <Link
                  className="icon"
                  href="https://www.linkedin.com/in/bryan-loh-11153a113/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedinIcon/>
                </Link>

                <Link
                  className="icon"
                  href="https://www.instagram.com/_bryanisms/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon/>
                </Link>

                <Link
                  className="icon"
                  href="https://twitter.com/_bryanisms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TwitterIcon/>
                </Link>
              </div>
            </div>
          </section>

        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App.js